export enum SignalREvents {
  TenantSubscription = 'TenantSubscription',
  ContactVerification = 'ContactVerificationPassed',
  MessageChannelSms = 'MessagingSmsToChannel',
  MessagingWhatsAppToChannel = 'MessagingWhatsAppToChannel',
  PsaTechVerification = 'PsaTechVerificationSmsRequest',
  TeamsChatMessage = 'TeamsChatMessage',
  // CallScribe — pushed by VoiceReceiverController when a Twilio status callback flips a call's status,
  // and by the post-call intelligence pipeline when summarisation finishes. Subscribed by useSignalRCallEvents.
  CallScribeStatusChanged = 'CallScribeStatusChanged',
  CallScribeIntelligenceReady = 'CallScribeIntelligenceReady',
  CallScribePipelineProgress = 'CallScribePipelineProgress',
  CallScribeTranscriptSegment = 'CallScribeTranscriptSegment',
  CallScribeParticipantsUpdated = 'CallScribeParticipantsUpdated',
}
